import React, { useEffect, useState } from 'react';
import './liedseite.css';
import { Link, useParams } from 'react-router-dom';

const db_api = 'https://liedersammlung.com/api.php';

function LiedDetail() {
  const { id } = useParams();
  const [lied, setLied] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isFavorite, setIsFavorite] = useState(false);

  function getFavorites() {
    return JSON.parse(localStorage.getItem('favorites') || '[]');
  }

  function checkFavorite(songId) {
    const favorites = getFavorites().map(String);
    return favorites.includes(String(songId));
  }
  const formatKategorie = (value) => {
    if (!value) return '';
    const withSpaces = value.replace(/_/g, ' ');
    const words = withSpaces.split(' ').filter(Boolean);
    const smallWords = new Set(['und', 'oder', 'vom', 'von', 'der', 'die', 'das', 'im', 'am', 'zum', 'zur']);
    return words
      .map((word, index) => {
        const lower = word.toLowerCase();
        if (index !== 0 && smallWords.has(lower)) return lower;
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      })
      .join(' ');
  };

  useEffect(() => {
    setIsFavorite(checkFavorite(id));
    let cancelled = false;

    async function loadLied() {
      try {
        setLoading(true);
        setError('');

        const response = await fetch(`${db_api}?id=${encodeURIComponent(id)}`);
        const data = await response.json();

        const record = Array.isArray(data) ? data[0] : data;

        setLied(record);
      } catch (err) { } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadLied();

    return () => {
      cancelled = true;
    };
  }, [id]);

  function manageFavorite(songId) {
    const favorites = getFavorites().map(String);
    const normalizedId = String(songId);

    if (!favorites.includes(normalizedId)) {
      const updatedFavorites = [...favorites, normalizedId];
      localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
      setIsFavorite(true);
      return;
    }

    const updatedFavorites = favorites.filter((favId) => favId !== normalizedId);
    localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
    setIsFavorite(false);
  }
  return (
    <>
      {!loading && !error && lied && (
        <>
        <div id='liedseite_body'>
          <div className='lied_info'>
            
            
            <div className='infoheader'>
              <div className='titel_block'>
              <h2 className='liedseite_titel'>{lied.name}</h2>
              {/*<div className='kategorie'>{lied.id} - {formatKategorie(lied.kategorie)}</div>*/}
              <div className='tonlage'>{lied.tonlage}</div>
              </div>
              <button type='button' className='fav_btn' aria-label='Zu Favoriten' onClick={() => manageFavorite(lied.id)}>
                {isFavorite ? 'favorite' : 'favorite_border'}
              </button>
              
            </div>
            <div className='kategorie'>{formatKategorie(lied.kategorie)}</div>
          </div>
          
            <div className='lied_content'>
              {lied.bloecke.map((block, index) => (
                <div
                  key={`${block.block_typ}-${block.reihenfolge}-${index}`}
                  className={block.block_typ === 'chor' ? 'chor' : 'strophe'}
                >
                  {block.text}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default LiedDetail;
